module.exports = __webpack_public_path__ + "static/media/BG_24.4e68597a.png";